/* eslint-disable no-console */
import * as os from 'os';
import * as path from 'path';
import chalk from 'chalk';
import { writeFileSync, mkdirSync } from 'fs';
import { DEBUG_MODE } from '../commons/config';

export function writeStackTrace(err?: Error) {
    if (err?.message?.includes('SIGINT')) {
        return; // no need to generate a log file for a sigint.
    }
    try {
        const homedir = os.homedir();

        mkdirSync(path.resolve(homedir, '.testim_logs'), { recursive: true });
        const logFileName = path.resolve(homedir, '.testim_logs', `${new Date().toISOString().replace(/:|\./g, '_')}.log`);
        console.log('Oops :( The test runner has encountered an unexpected error. A complete log of this run can be found in:');
        console.log(`\t${logFileName}`);
        if (DEBUG_MODE) { //TODO: This is part of TES-12584, remove once we have sufficient logs for schedulers aborted
            console.log(`Call stack: ${err?.stack}`);
        }

        if (err?.message?.includes('Unable to compile TypeScript') && err.stack?.includes('runner/src') && process.argv.some(x => x.includes('player-require-path'))) {
            console.log(chalk.red('Looks like you got a TypeScript compile error champ - but it\'s not a very good one because we use TypeScript in transpile-only mode'));
            console.log(chalk.red('change require(\'ts-node/register/transpile-only\'); to require(\'ts-node/register\'); for better errors'));
        }

        writeFileSync(logFileName, `${err}\n${err?.stack}\n\n${JSON.stringify(err, Object.getOwnPropertyNames(err), 2)}`);
    } catch { /* noop */ }
}
